/**
 * 泰康车险 - 广东省车牌 JS
 * @Author 吴成林
 * @Date
 */
export default {
  provincesList: [
    {
        "label":"广东省",
        "value":"440000",
        "children": [
            {
                "provinceId":"440000","label":"广州市", "value":"440100", "licensePrefix":"粤A",
            },
            {
                "provinceId":"440000", "label":"韶关市", "value":"440200", "licensePrefix":"粤F",
            },
            {
                "provinceId":"440000","label":"珠海市","value":"440400","licensePrefix":"粤C",
            },
            {
                "provinceId":"440000","label":"汕头市","value":"440500","licensePrefix":"粤D",
            },
            {
                "provinceId":"440000","label":"佛山市","value":"440600","licensePrefix":"粤E,粤X,粤Y",
            },
            {
                "provinceId":"440000","label":"江门市","value":"440700","licensePrefix":"粤J",
            },
            {
                "provinceId":"440000","label":"湛江市","value":"440800","licensePrefix":"粤G",
            },
            {
                "provinceId":"440000","label":"茂名市","value":"440900","licensePrefix":"粤K",
            },
            {
                "provinceId":"440000","label":"肇庆市","value":"441200","licensePrefix":"粤H",
            },
            {
                "provinceId":"440000","label":"惠州市","value":"441300","licensePrefix":"粤L",
            },
            {
                "provinceId":"440000","label":"梅州市","value":"441400","licensePrefix":"粤M",
            },
            {
                "provinceId":"440000","label":"汕尾市","value":"441500","licensePrefix":"粤N",
            },
            {
                "provinceId":"440000", "label":"河源市", "value":"441600", "licensePrefix":"粤P",
            },
            {
                "provinceId":"440000", "label":"阳江市", "value":"441700", "licensePrefix":"粤Q",
            },
            {
                "provinceId":"440000", "label":"清远市", "value":"441800", "licensePrefix":"粤R",
            },
            {
                "provinceId":"440000", "label":"东莞市", "value":"441900", "licensePrefix":"粤S",
            },
            {
                "provinceId":"440000", "label":"中山市", "value":"442000", "licensePrefix":"粤T",
            },
            {
                "provinceId":"440000", "label":"潮州市", "value":"445100", "licensePrefix":"粤U",
            },
            {
                "provinceId":"440000", "label":"揭阳市", "value":"445200", "licensePrefix":"粤V",
            },
            {
                "provinceId":"440000", "label":"云浮市", "value":"445300", "licensePrefix":"粤W",
            },
            {
                "provinceId":"440000", "label":"深圳市","value":"440300", "licensePrefix":"粤B",
            }
        ]
    }
  ],

  companyProvinceList: [{"label":"广东省","value":"440000","children":[{"provinceId":"440000","label":"广州市","value":"440100"},
        {"provinceId":"440000","label":"韶关市","value":"440200"},
        {"provinceId":"440000","label":"珠海市","value":"440400"},
        {"provinceId":"440000","label":"汕头市","value":"440500"},
        {"provinceId":"440000","label":"佛山市","value":"440600"},
        {"provinceId":"440000","label":"江门市","value":"440700"},
        {"provinceId":"440000","label":"湛江市","value":"440800"},
        {"provinceId":"440000","label":"茂名市","value":"440900"},
        {"provinceId":"440000","label":"肇庆市","value":"441200"},
        {"provinceId":"440000","label":"惠州市","value":"441300"},
        {"provinceId":"440000","label":"梅州市","value":"441400"},
        {"provinceId":"440000","label":"汕尾市","value":"441500"},
        {"provinceId":"440000","label":"河源市","value":"441600"},
        {"provinceId":"440000","label":"阳江市","value":"441700"},
        {"provinceId":"440000","label":"清远市","value":"441800"},
        {"provinceId":"440000","label":"东莞市","value":"441900"},
        {"provinceId":"440000","label":"中山市","value":"442000"},
        {"provinceId":"440000","label":"潮州市","value":"445100"},
        {"provinceId":"440000","label":"揭阳市","value":"445200"},
        {"provinceId":"440000","label":"云浮市","value":"445300"}]},
    {"label":"北京市","value":"110000","children":[{"provinceId":"110000","label":"北京市","value":"110000"}]},
    {"label":"天津市","value":"120000","children":[{"provinceId":"120000","label":"天津市","value":"120000"}]},
    {"label":"上海市","value":"310000","children":[{"provinceId":"310000","label":"上海市","value":"310000"}]},
    {"label":"重庆市","value":"500000","children":[{"provinceId":"500000","label":"重庆市","value":"500000"}]},
    {"label":"大连市","value":"210200","children":[{"provinceId":"210200","label":"大连市","value":"210200"}]},
    {"label":"河北省","value":"130000","children":[{"provinceId":"130000","label":"石家庄市","value":"130100"},
            {"provinceId":"130000","label":"唐山市","value":"130200"},
            {"provinceId":"130000","label":"秦皇岛市","value":"130300"},
            {"provinceId":"130000","label":"邯郸市","value":"130400"},
            {"provinceId":"130000","label":"邢台市","value":"130500"},
            {"provinceId":"130000","label":"保定市","value":"130600"},
            {"provinceId":"130000","label":"张家口市","value":"130700"},
            {"provinceId":"130000","label":"承德市","value":"130800"},
            {"provinceId":"130000","label":"沧州市","value":"130900"},
            {"provinceId":"130000","label":"廊坊市","value":"131000"},
            {"provinceId":"130000","label":"衡水市","value":"131100"}]},
    {"label":"山西省","value":"140000","children":[{"provinceId":"140000","label":"太原市","value":"140100"},
            {"provinceId":"140000","label":"大同市","value":"140200"},
            {"provinceId":"140000","label":"阳泉市","value":"140300"},
            {"provinceId":"140000","label":"长治市","value":"140400"},
            {"provinceId":"140000","label":"晋城市","value":"140500"},
            {"provinceId":"140000","label":"朔州市","value":"140600"},
            {"provinceId":"140000","label":"晋中市","value":"140700"},
            {"provinceId":"140000","label":"运城市","value":"140800"},
            {"provinceId":"140000","label":"忻州市","value":"140900"},
            {"provinceId":"140000","label":"临汾市","value":"141000"},
            {"provinceId":"140000","label":"吕梁市","value":"141100"}]},
    {"label":"内蒙古","value":"150000","children":[{"provinceId":"150000","label":"呼和浩特市","value":"150100"},
            {"provinceId":"150000","label":"包头市","value":"150200"},
            {"provinceId":"150000","label":"乌海市","value":"150300"},
            {"provinceId":"150000","label":"赤峰市","value":"150400"},
            {"provinceId":"150000","label":"通辽市","value":"150500"},
            {"provinceId":"150000","label":"鄂尔多斯市","value":"150600"},
            {"provinceId":"150000","label":"呼伦贝尔市","value":"150700"},
            {"provinceId":"150000","label":"巴彦淖尔市","value":"150800"},
            {"provinceId":"150000","label":"乌兰察布市","value":"150900"},
            {"provinceId":"150000","label":"兴安盟","value":"152200"},
            {"provinceId":"150000","label":"锡林郭勒盟","value":"152500"},
            {"provinceId":"150000","label":"阿拉善盟","value":"152900"}]},
    {"label":"辽宁省","value":"210000","children":[{"provinceId":"210000","label":"沈阳市","value":"210100"},
            {"provinceId":"210000","label":"鞍山市","value":"210300"},
            {"provinceId":"210000","label":"抚顺市","value":"210400"},
            {"provinceId":"210000","label":"本溪市","value":"210500"},
            {"provinceId":"210000","label":"丹东市","value":"210600"},
            {"provinceId":"210000","label":"锦州市","value":"210700"},
            {"provinceId":"210000","label":"营口市","value":"210800"},
            {"provinceId":"210000","label":"阜新市","value":"210900"},
            {"provinceId":"210000","label":"辽阳市","value":"211000"},
            {"provinceId":"210000","label":"盘锦市","value":"211100"},
            {"provinceId":"210000","label":"铁岭市","value":"211200"},
            {"provinceId":"210000","label":"朝阳市","value":"211300"},
            {"provinceId":"210000","label":"葫芦岛市","value":"211400"}]},
    {"label":"吉林省","value":"220000","children":[{"provinceId":"220000","label":"长春市","value":"220100"},
            {"provinceId":"220000","label":"长春市","value":"220100"},
            {"provinceId":"220000","label":"吉林市","value":"220200"},
            {"provinceId":"220000","label":"四平市","value":"220300"},
            {"provinceId":"220000","label":"辽源市","value":"220400"},
            {"provinceId":"220000","label":"通化市","value":"220500"},
            {"provinceId":"220000","label":"白山市","value":"220600"},
            {"provinceId":"220000","label":"松原市","value":"220700"},
            {"provinceId":"220000","label":"白城市","value":"220800"},
            {"provinceId":"220000","label":"延边朝鲜族自治州","value":"222400"}]},
    {"label":"黑龙江省","value":"230000","children":[{"provinceId":"230000","label":"哈尔滨市","value":"230100"},
            {"provinceId":"230000","label":"齐齐哈尔市","value":"230200"},
            {"provinceId":"230000","label":"鸡西市","value":"230300"},
            {"provinceId":"230000","label":"鹤岗市","value":"230400"},
            {"provinceId":"230000","label":"双鸭山市","value":"230500"},
            {"provinceId":"230000","label":"大庆市","value":"230600"},
            {"provinceId":"230000","label":"伊春市","value":"230700"},
            {"provinceId":"230000","label":"佳木斯市","value":"230800"},
            {"provinceId":"230000","label":"七台河市","value":"230900"},
            {"provinceId":"230000","label":"牡丹江市","value":"231000"},
            {"provinceId":"230000","label":"黑河市","value":"231100"},
            {"provinceId":"230000","label":"绥化市","value":"231200"},
            {"provinceId":"230000","label":"大兴安岭地区","value":"232700"}]},
    {"label":"江苏省","value":"320000","children":[{"provinceId":"320000","label":"南京市","value":"320100"},
            {"provinceId":"320000","label":"无锡市","value":"320200"},
            {"provinceId":"320000","label":"徐州市","value":"320300"},
            {"provinceId":"320000","label":"常州市","value":"320400"},
            {"provinceId":"320000","label":"苏州市","value":"320500"},
            {"provinceId":"320000","label":"南通市","value":"320600"},
            {"provinceId":"320000","label":"连云港市","value":"320700"},
            {"provinceId":"320000","label":"淮安市","value":"320800"},
            {"provinceId":"320000","label":"盐城市","value":"320900"},
            {"provinceId":"320000","label":"扬州市","value":"321000"},
            {"provinceId":"320000","label":"镇江市","value":"321100"},
            {"provinceId":"320000","label":"泰州市","value":"321200"},
            {"provinceId":"320000","label":"宿迁市","value":"321300"}]},
    {"label":"浙江省","value":"330000","children":[{"provinceId":"330000","label":"杭州市","value":"330100"},
            {"provinceId":"330000","label":"宁波市","value":"330200"},
            {"provinceId":"330000","label":"温州市","value":"330300"},
            {"provinceId":"330000","label":"嘉兴市","value":"330400"},
            {"provinceId":"330000","label":"湖州市","value":"330500"},
            {"provinceId":"330000","label":"绍兴市","value":"330600"},
            {"provinceId":"330000","label":"金华市","value":"330700"},
            {"provinceId":"330000","label":"衢州市","value":"330800"},
            {"provinceId":"330000","label":"舟山市","value":"330900"},
            {"provinceId":"330000","label":"台州市","value":"331000"},
            {"provinceId":"330000","label":"丽水市","value":"331100"}]},
    {"label":"安徽省","value":"340000","children":[{"provinceId":"340000","label":"合肥市","value":"340100"},
            {"provinceId":"340000","label":"芜湖市","value":"340200"},
            {"provinceId":"340000","label":"蚌埠市","value":"340300"},
            {"provinceId":"340000","label":"淮南市","value":"340400"},
            {"provinceId":"340000","label":"马鞍山市","value":"340500"},
            {"provinceId":"340000","label":"淮北市","value":"340600"},
            {"provinceId":"340000","label":"铜陵市","value":"340700"},
            {"provinceId":"340000","label":"安庆市","value":"340800"},
            {"provinceId":"340000","label":"黄山市","value":"341000"},
            {"provinceId":"340000","label":"滁州市","value":"341100"},
            {"provinceId":"340000","label":"阜阳市","value":"341200"},
            {"provinceId":"340000","label":"宿州市","value":"341300"},
            {"provinceId":"340000","label":"六安市","value":"341500"},
            {"provinceId":"340000","label":"亳州市","value":"341600"},
            {"provinceId":"340000","label":"池州市","value":"341700"},
            {"provinceId":"340000","label":"宣城市","value":"341800"}]},
    {"label":"福建省","value":"350000","children":[{"provinceId":"350000","label":"福州市","value":"350100"},
            {"provinceId":"350000","label":"厦门市","value":"350200"},
            {"provinceId":"350000","label":"莆田市","value":"350300"},
            {"provinceId":"350000","label":"三明市","value":"350400"},
            {"provinceId":"350000","label":"泉州市","value":"350500"},
            {"provinceId":"350000","label":"漳州市","value":"350600"},
            {"provinceId":"350000","label":"南平市","value":"350700"},
            {"provinceId":"350000","label":"龙岩市","value":"350800"},
            {"provinceId":"350000","label":"宁德市","value":"350900"}]},
    {"label":"江西省","value":"360000","children":[
            {"provinceId":"360000","label":"南昌市","value":"360100"},
            {"provinceId":"360000","label":"景德镇市","value":"360200"},
            {"provinceId":"360000","label":"萍乡市","value":"360300"},
            {"provinceId":"360000","label":"九江市","value":"360400"},
            {"provinceId":"360000","label":"新余市","value":"360500"},
            {"provinceId":"360000","label":"鹰潭市","value":"360600"},
            {"provinceId":"360000","label":"赣州市","value":"360700"},
            {"provinceId":"360000","label":"吉安市","value":"360800"},
            {"provinceId":"360000","label":"宜春市","value":"360900"},
            {"provinceId":"360000","label":"抚州市","value":"361000"},
            {"provinceId":"360000","label":"上饶市","value":"361100"}]},
    {"label":"山东省","value":"370000","children":[
            {"provinceId":"360000","label":"济南市","value":"370100"},
            {"provinceId":"360000","label":"青岛市","value":"370200"},
            {"provinceId":"360000","label":"淄博市","value":"370300"},
            {"provinceId":"360000","label":"枣庄市","value":"370400"},
            {"provinceId":"360000","label":"东营市","value":"370500"},
            {"provinceId":"360000","label":"烟台市","value":"370600"},
            {"provinceId":"360000","label":"潍坊市","value":"370700"},
            {"provinceId":"360000","label":"济宁市","value":"370800"},
            {"provinceId":"360000","label":"泰安市","value":"370900"},
            {"provinceId":"360000","label":"威海市","value":"371000"},
            {"provinceId":"360000","label":"日照市","value":"371100"},
            {"provinceId":"360000","label":"莱芜市","value":"371200"},
            {"provinceId":"360000","label":"临沂市","value":"371300"},
            {"provinceId":"360000","label":"德州市","value":"371400"},
            {"provinceId":"360000","label":"聊城市","value":"371500"},
            {"provinceId":"360000","label":"滨州市","value":"371600"},
            {"provinceId":"360000","label":"菏泽市","value":"371700"}]},
    {"label":"河南省","value":"410000","children":[{"provinceId":"410000","label":"郑州市","value":"410100"},
            {"provinceId":"410000","label":"开封市","value":"410200"},
            {"provinceId":"410000","label":"洛阳市","value":"410300"},
            {"provinceId":"410000","label":"平顶山市","value":"410400"},
            {"provinceId":"410000","label":"安阳市","value":"410500"},
            {"provinceId":"410000","label":"鹤壁市","value":"410600"},
            {"provinceId":"410000","label":"新乡市","value":"410700"},
            {"provinceId":"410000","label":"焦作市","value":"410800"},
            {"provinceId":"410000","label":"濮阳市","value":"410900"},
            {"provinceId":"410000","label":"许昌市","value":"411000"},
            {"provinceId":"410000","label":"漯河市","value":"411100"},
            {"provinceId":"410000","label":"三门峡市","value":"411200"},
            {"provinceId":"410000","label":"南阳市","value":"411300"},
            {"provinceId":"410000","label":"商丘市","value":"411400"},
            {"provinceId":"410000","label":"信阳市","value":"411500"},
            {"provinceId":"410000","label":"周口市","value":"411600"},
            {"provinceId":"410000","label":"驻马店市","value":"411700"},
            {"provinceId":"410000","label":"济源市","value":"419001"}]},
    {"label":"湖北省","value":"420000","children":[{"provinceId":"420000","label":"武汉市","value":"420100"},
            {"provinceId":"420000","label":"黄石市","value":"420200"},
            {"provinceId":"420000","label":"十堰市","value":"420300"},
            {"provinceId":"420000","label":"宜昌市","value":"420500"},
            {"provinceId":"420000","label":"襄阳市","value":"420600"},
            {"provinceId":"420000","label":"鄂州市","value":"420700"},
            {"provinceId":"420000","label":"荆门市","value":"420800"},
            {"provinceId":"420000","label":"孝感市","value":"420900"},
            {"provinceId":"420000","label":"荆州市","value":"421000"},
            {"provinceId":"420000","label":"黄冈市","value":"421100"},
            {"provinceId":"420000","label":"咸宁市","value":"421200"},
            {"provinceId":"420000","label":"随州市","value":"421300"},
            {"provinceId":"420000","label":"恩施土家族苗族自治州","value":"422800"},
            {"provinceId":"420000","label":"省直辖县级行政区划","value":"429000"}]},
    {"label":"湖南省 ","value":"430000","children":[{"provinceId":"430000","label":"长沙市","value":"430100"},
            {"provinceId":"430000","label":" 株洲市","value":"430200"},
            {"provinceId":"430000","label":" 湘潭市","value":"430300"},
            {"provinceId":"430000","label":" 衡阳市","value":"430400"},
            {"provinceId":"430000","label":" 邵阳市","value":"430500"},
            {"provinceId":"430000","label":" 岳阳市","value":"430600"},
            {"provinceId":"430000","label":" 常德市","value":"430700"},
            {"provinceId":"430000","label":" 张家界市","value":"430800"},
            {"provinceId":"430000","label":" 益阳市","value":"430900"},
            {"provinceId":"430000","label":" 郴州市","value":"431000"},
            {"provinceId":"430000","label":" 永州市","value":"431100"},
            {"provinceId":"430000","label":" 怀化市","value":"431200"},
            {"provinceId":"430000","label":" 娄底市","value":"431300"},
            {"provinceId":"430000","label":"湘西土家族苗族自治州","value":"433100"}]},
    {"label":"广西壮族自治区","value":"450000","children":[{"provinceId":"450000","label":"南宁市","value":"450100"},
            {"provinceId":"450000","label":"柳州市","value":"450200"},
            {"provinceId":"450000","label":"桂林市","value":"450300"},
            {"provinceId":"450000","label":"梧州市","value":"450400"},
            {"provinceId":"450000","label":"北海市","value":"450500"},
            {"provinceId":"450000","label":"防城港市","value":"450600"},
            {"provinceId":"450000","label":"钦州市","value":"450700"},
            {"provinceId":"450000","label":"贵港市","value":"450800"},
            {"provinceId":"450000","label":"玉林市","value":"450900"},
            {"provinceId":"450000","label":"百色市","value":"451000"},
            {"provinceId":"450000","label":"贺州市","value":"451100"},
            {"provinceId":"450000","label":"河池市","value":"451200"},
            {"provinceId":"450000","label":"来宾市","value":"451300"},
            {"provinceId":"450000","label":"崇左市","value":"451400"}]},
    {"label":"海南省","value":"460000","children":[{"provinceId":"460000","label":"海口市","value":"460100"},
            {"provinceId":"460000","label":"三亚市","value":"460200"},
            {"provinceId":"460000","label":"三沙市","value":"460300"},
            {"provinceId":"460000","label":"省直辖县级行政区划","value":"469000"}]},
    {"label":"四川省","value":"510000","children":[{"provinceId":"460000","label":"成都市","value":"510100"},
            {"provinceId":"460000","label":"自贡市","value":"510300"},
            {"provinceId":"460000","label":"攀枝花市","value":"510400"},
            {"provinceId":"460000","label":"泸州市","value":"510500"},
            {"provinceId":"460000","label":"德阳市","value":"510600"},
            {"provinceId":"460000","label":"绵阳市","value":"510700"},
            {"provinceId":"460000","label":"广元市","value":"510800"},
            {"provinceId":"460000","label":"遂宁市","value":"510900"},
            {"provinceId":"460000","label":"内江市","value":"511000"},
            {"provinceId":"460000","label":"乐山市","value":"511100"},
            {"provinceId":"460000","label":"南充市","value":"511300"},
            {"provinceId":"460000","label":"眉山市","value":"511400"},
            {"provinceId":"460000","label":"宜宾市","value":"511500"},
            {"provinceId":"460000","label":"广安市","value":"511600"},
            {"provinceId":"460000","label":"达州市","value":"511700"},
            {"provinceId":"460000","label":"雅安市","value":"511800"},
            {"provinceId":"460000","label":"巴中市","value":"511900"},
            {"provinceId":"460000","label":"资阳市","value":"512000"},
            {"provinceId":"460000","label":"阿坝藏族羌族自治州","value":"513200"},
            {"provinceId":"460000","label":"甘孜藏族自治州","value":"513300"},
            {"provinceId":"460000","label":"凉山彝族自治州","value":"513400"}]},
    {"label":"贵州省","value":"520000","children":[{"provinceId":"520000","label":"贵阳市","value":"520100"},
            {"provinceId":"520000","label":"六盘水市","value":"520200"},
            {"provinceId":"520000","label":"遵义市","value":"520300"},
            {"provinceId":"520000","label":"安顺市","value":"520400"},
            {"provinceId":"520000","label":"毕节市","value":"520500"},
            {"provinceId":"520000","label":"铜仁市","value":"520600"},
            {"provinceId":"520000","label":"黔西南布依族苗族自治州","value":"522300"},
            {"provinceId":"520000","label":"黔东南苗族侗族自治州","value":"522600"},
            {"provinceId":"520000","label":"黔南布依族苗族自治州","value":"522700"}]},
    {"label":"云南省","value":"530000","children":[{"provinceId":"530000","label":"昆明市","value":"530100"},
            {"provinceId":"530000","label":"曲靖市","value":"530300"},
            {"provinceId":"530000","label":"玉溪市","value":"530400"},
            {"provinceId":"530000","label":"保山市","value":"530500"},
            {"provinceId":"530000","label":"昭通市","value":"530600"},
            {"provinceId":"530000","label":"丽江市","value":"530700"},
            {"provinceId":"530000","label":"普洱市","value":"530800"},
            {"provinceId":"530000","label":"临沧市","value":"530900"},
            {"provinceId":"530000","label":"楚雄彝族自治州","value":"532300"},
            {"provinceId":"530000","label":"红河哈尼族彝族自治州","value":"532500"},
            {"provinceId":"530000","label":"文山壮族苗族自治州","value":"532600"},
            {"provinceId":"530000","label":"西双版纳傣族自治州","value":"532800"},
            {"provinceId":"530000","label":"大理白族自治州","value":"532900"},
            {"provinceId":"530000","label":"德宏傣族景颇族自治州","value":"533100"},
            {"provinceId":"530000","label":"怒江傈僳族自治州","value":"533300"},
            {"provinceId":"530000","label":"迪庆藏族自治州","value":"533400"}]},
    {"label":"西藏自治区","value":"540000","children":[{"provinceId":"530000","label":"拉萨市","value":"540100"},
            {"provinceId":"530000","label":"昌都地区","value":"542100"},
            {"provinceId":"530000","label":"山南地区","value":"542200"},
            {"provinceId":"530000","label":"日喀则地区","value":"542300"},
            {"provinceId":"530000","label":"那曲地区","value":"542400"},
            {"provinceId":"530000","label":"阿里地区","value":"542500"},
            {"provinceId":"530000","label":"林芝地区","value":"542600"}]},
    {"label":"陕西省","value":"610000","children":[{"provinceId":"610000","label":"西安市","value":"610100"},
            {"provinceId":"610000","label":"铜川市","value":"610200"},
            {"provinceId":"610000","label":"宝鸡市","value":"610300"},
            {"provinceId":"610000","label":"咸阳市","value":"610400"},
            {"provinceId":"610000","label":"渭南市","value":"610500"},
            {"provinceId":"610000","label":"延安市","value":"610600"},
            {"provinceId":"610000","label":"汉中市","value":"610700"},
            {"provinceId":"610000","label":"榆林市","value":"610800"},
            {"provinceId":"610000","label":"安康市","value":"610900"},
            {"provinceId":"610000","label":"商洛市","value":"611000"}]},
    {"label":"甘肃省","value":"620000","children":[{"provinceId":"620000","label":"兰州市","value":"620100"},
            {"provinceId":"620000","label":"嘉峪关市","value":"620200"},
            {"provinceId":"620000","label":"金昌市","value":"620300"},
            {"provinceId":"620000","label":"白银市","value":"620400"},
            {"provinceId":"620000","label":"天水市","value":"620500"},
            {"provinceId":"620000","label":"武威市","value":"620600"},
            {"provinceId":"620000","label":"张掖市","value":"620700"},
            {"provinceId":"620000","label":"平凉市","value":"620800"},
            {"provinceId":"620000","label":"酒泉市","value":"620900"},
            {"provinceId":"620000","label":"庆阳市","value":"621000"},
            {"provinceId":"620000","label":"定西市","value":"621100"},
            {"provinceId":"620000","label":"陇南市","value":"621200"},
            {"provinceId":"620000","label":"临夏回族自治州","value":"622900"},
            {"provinceId":"620000","label":"甘南藏族自治州","value":"623000"}]},
    {"label":"青海省","value":"630000","children":[{"provinceId":"630000","label":"西宁市","value":"630100"},
            {"provinceId":"630000","label":"海东市","value":"630200"},
            {"provinceId":"630000","label":"海北藏族自治州","value":"632200"},
            {"provinceId":"630000","label":"黄南藏族自治州","value":"632300"},
            {"provinceId":"630000","label":"海南藏族自治州","value":"632500"},
            {"provinceId":"630000","label":"果洛藏族自治州","value":"632600"},
            {"provinceId":"630000","label":"玉树藏族自治州","value":"632700"},
            {"provinceId":"630000","label":"海西蒙古族藏族自治州","value":"632800"}]},
    {"label":"宁夏回族自治区","value":"640000","children":[{"provinceId":"640000","label":"银川市","value":"640100"},
            {"provinceId":"640000","label":"石嘴山市","value":"640200"},
            {"provinceId":"640000","label":"吴忠市","value":"640300"},
            {"provinceId":"640000","label":"固原市","value":"640400"},
            {"provinceId":"640000","label":"中卫市","value":"640500"}]},
    {"label":"新疆维吾尔自治区","value":"650000","children":[{"provinceId":"650000","label":"乌鲁木齐市","value":"650100"},
            {"provinceId":"650000","label":"克拉玛依市","value":"650200"},
            {"provinceId":"650000","label":"吐鲁番地区","value":"652100"},
            {"provinceId":"650000","label":"哈密地区","value":"652200"},
            {"provinceId":"650000","label":"昌吉回族自治州","value":"652300"},
            {"provinceId":"650000","label":"博尔塔拉蒙古自治州","value":"652700"},
            {"provinceId":"650000","label":"巴音郭楞蒙古自治州","value":"652800"},
            {"provinceId":"650000","label":"阿克苏地区","value":"652900"},
            {"provinceId":"650000","label":"克孜勒苏柯尔克孜自治州","value":"653000"},
            {"provinceId":"650000","label":"喀什地区","value":"653100"},
            {"provinceId":"650000","label":"和田地区","value":"653200"},
            {"provinceId":"650000","label":"伊犁哈萨克自治州","value":"654000"},
            {"provinceId":"650000","label":"塔城地区","value":"654200"},
            {"provinceId":"650000","label":"阿勒泰地区","value":"654300"},
            {"provinceId":"650000","label":"自治区直辖县级行政区划","value":"659000"}]
  }],
}



// WEBPACK FOOTER //
// ./src/tool/resource/province.js